import React from "react"
import { useIntl } from "gatsby-plugin-intl"
import { Link, graphql, useStaticQuery } from "gatsby"
import TocElement from "./TocElement"

export default function Toc(props) {
  const intl = useIntl()
  const data = useStaticQuery(graphql`
    query ListGrainsFromModule {
      allLessonsJson(sort: {grainId: ASC}) {
        edges {
          node {
            id
            name { en,fr,it,es,bg }
            notion
            grainId
            module
          }
        }
      }
    }
  `)

  const showToC = () => {
    document.getElementById("toc").style.display = "block"
    document.getElementById("showToc").style.display = "none"
  }

  const allLessonsFromCurrentModule = data.allLessonsJson.edges
    .filter(grain => grain.node.module === props.module)
    .map(grain => grain.node)

  // Order by grains ID
  allLessonsFromCurrentModule.sort((a, b) => {
    return a.grainId - b.grainId;
  });

  // List all notions from grains uploaded
  let notions = []
  allLessonsFromCurrentModule.forEach(grain => {
    !notions.includes(grain.notion) && notions.push(grain.notion)
  })

  // Get module name in lowercase
  const module = props.module.toLowerCase();

  return (
    <>
      <section className="content--main--toc whiteBackground lessons__toc">
        <div id="toc">
          {notions
            .filter(notion => notion === props.notion)
            .map((notion, index) => (
              <div key={index} className="lessons__toc__notion">
                <h2 style={{ color: `${props.colors.primary}` }}>
                  <span>{intl.formatMessage({ id: "training11" })} {notion}</span>
                  <span>{intl.formatMessage({ id: `${module}lessons${notion - 1}` })}</span>
                </h2>
                <ul>
                  {allLessonsFromCurrentModule
                    .filter(
                      grain =>
                        grain.notion === notion
                    )
                    .map((grain, index) => (
                      <TocElement
                        key={index}
                        colors={props.colors}
                        grainId={String(grain.grainId)}
                        currentGrain={props.grainId}
                        name={grain.name[intl.locale]}
                        module={grain.module}
                      />
                    ))}
                </ul>
              </div>
            ))}
        </div>
        <div className="content--fullwidth">
          <button
            onClick={showToC}
            id="showToc"
            style={{
              backgroundColor: `${props.colors.primary}`,
              color: props.colors.secondary,
              cursor: "pointer",
            }}
          >
            {intl.formatMessage({ id: "training24" })}
          </button>
          <Link
            id="showAll"
            style={{
              backgroundColor: `${props.colors.primary}`,
              color: props.colors.secondary,
              cursor: "pointer",
            }}
            to="../"
          >
            {intl.formatMessage({ id: "training13" })}
          </Link>
        </div>
      </section>
      {}
    </>
  )
}
